import alt from '../alt';
import condoSetAction from '../actions/condoSetAction';

class condoSetStore {
    constructor() {
        this.bindActions(condoSetAction);
        this.processing = false;
        this.isCLUpdate = false;
        this.editContractor = [];
        this.removeContractor = [];
        this.warningMsg = "";
        this.checkList = [];
        this.prevMCST = "";
        this.condo = {
            _id: "",
            mcst: "",
            condoName: "",
            noUnit: "",
            address: "",
            postal: "",
            geoLocation: { type: "Point", coordinates: ["", ""] },
            manageBy: {},
            supervisor:{},
            checkList: [],
            contractors:[],
            status:0,
        }
    }
    onReset(){
        this.updating = false;
        this.search="";
        this.isNew = false;
        this.filterByCriteria = false;
        this.csMode = 1;
    }
    onClear() {
        this.condo = {
            _id: "",
            mcst: "",
            condoName: "",
            noUnit: "",
            address: "",
            postal: "",
            radius:0,
            geoLocation: { type: "Point", coordinates: ["", ""] },
            manageBy: {staffId:""},
            supervisor:{staffId:""},
            checkList: [],
            contractors:[],
            status:0,

        }
        this.editContractor = [];
        this.removeContractor = [];
        this.editCheckList = [];
        this.newFacility = [];
        this.isCLUpdate = false;
    }
   
    onProcessing(data) {
        this.processing = data;
    }
    
    onUpdating(data) {
        this.updating = data;
    }
    
    onWarningMsg(data) {
        this.warningMsg = data;
    }
   
    onCheckListSuccess(data) {
        this.checkList = data;
    }
    onCondoSuccess(data) {
        this.condo = data;
        this.prevMCST = data.mcst;
    }
    onAddCondoSuccess(){
        this.onClear();
    }
    onCondo(data) {
        this.condo = data;
    }
    onCheckList(data) {
        this.checkList = data;
    }
    
    onAddStaff(data) {
        this.condo.manageBy.push(data);
    }
    onRemoveStaff(data) {
        this.condo.manageBy.splice(data.index, 1);
    }
    onShouldListShow(data) {
        this.condo.contractors[data].shouldListShow = !this.condo.contractors[data].shouldListShow;
    }
    onShouldListShowCL(data) {
        this.condo.checkList[data].shouldListShow = !this.condo.checkList[data].shouldListShow;
    }
    onShouldListShowCL2(data) {
        this.checkList[data].shouldListShow = !this.checkList[data].shouldListShow;
    }
    onAddContractor(data) {
        data.contract = [];
        this.condo.contractors.push(data);
        //add to editContractor
        this.editContractor.push(data._id);

        //clear removeContractor
        let len = this.removeContractor.length;
        let pos = -1;
        for (let i = 0; i < len; i++) {
            if (this.removeContractor[i] == data._id) {
                pos = i;
                break;
            }
        }
        if (pos != -1) {
            this.removeContractor.splice(pos, 1);
        }
    }
    onAddService(data) {
        let len = this.condo.contractors.length;
        for (let i = 0; i < len; i++) {
            if (this.condo.contractors[i]._id == data.contractorId) {
                this.condo.contractors[i].contract.push(data.contract);
            }
        }
        //add to editContractor
        let isRepeat = false;
        let conLen = this.editContractor.length;
        for (let j = 0; j < conLen; j++) {
            if (this.editContractor[j] == data.contractorId) {
                isRepeat = true;
                break;
            }
        }
        if (!isRepeat) {
            this.editContractor.push(data.contractorId);
        }
    }
    onRemoveContractor(data) {
        this.removeContractor.push(data.contractorId);
        //check editContractor
        let len = this.editContractor.length;

        for (let i = 0; i < len; i++) {
            if (this.editContractor[i] == data.contractorId) {
                this.editContractor.splice(i, 1);
                break;
            }
        }

        //splice condo
        let conLen = this.condo.contractors.length;
        for (let j = 0; j < conLen; j++) {
            if (this.condo.contractors[j]._id == data.contractorId) {
                this.condo.contractors.splice(j, 1);
                break;
            }
        }
    }
    onEditService(data) {
        let len = this.editContractor.length;
        let isRepeat = false;
        for (let i = 0; i < len; i++) {
            if (this.editContractor[i] == data.contractorId) {
                isRepeat = true;
                break;
            }
        }
        if (!isRepeat) {
            this.editContractor.push(data.contractorId);
        }

        //splice condo
        let conLen = this.condo.contractors.length;
        for (let j = 0; j < conLen; j++) {
            if (this.condo.contractors[j]._id == data.contractorId) {
                this.condo.contractors[j].contract[data.index] = data.contract;
                break;
            }
        }
    }
    onRemoveService(data) {
        let len = this.editContractor.length;
        let isRepeat = false;
        for (let i = 0; i < len; i++) {
            if (this.editContractor[i] == data.contractorId) {
                isRepeat = true;
                break;
            }
        }
        if (!isRepeat) {
            this.editContractor.push(data.contractorId);
        }
        //splice condo
        let conLen = this.condo.contractors.length;
        for (let j = 0; j < conLen; j++) {
            if (this.condo.contractors[j]._id == data.contractorId) {
                this.condo.contractors[j].contract.splice(data.index, 1);
                break;
            }
        }
    }
    onCondoRemoveSuccess(data) {
        this.updating = false;
    }
    
    onIsCLUpdate(data) {
        this.isCLUpdate = data;
    }
}
export default alt.createStore(condoSetStore, 'condoSetStore');


// WEBPACK FOOTER //
// ./app/stores/condoSetStore.js